import Image from '@/components/Image';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

const PreviewCompatibleImage = ({ imageInfo, priority = false, ...props }) => {
  const { alt, image, width, layout, ...imgProps } = imageInfo;

  if (!!image && typeof image === 'string') {
    const { style, ...rest } = props;
    return (
      <div style={{ position: 'relative', ...style }} {...rest}>
        <NextImage src={image} alt={alt} fill priority={priority} {...imgProps} />
      </div>
    );
  }

  return <Image image={image} alt={alt} width={width} layout={layout} priority={priority} {...props} />;
};

PreviewCompatibleImage.propTypes = {
  imageInfo: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    style: PropTypes.object,
  }).isRequired,
};

export default PreviewCompatibleImage;
